import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.css']
})
export class InfoModalComponent implements OnInit {
@Output() close = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
  }


  closeModal(){
    this.close.emit();
  }

}
